module.exports = __webpack_public_path__ + "static/img/1.3eeda52a.png";